module.exports = __webpack_public_path__ + "img/site.b1760537.webp";